import { ICountryCode } from '../shared';

export const enum ContactUsActionTypes {
  CONTACTUS_CREATESUPPORTTICKET = '@@contactus/CONTACTUS_CREATESUPPORTTICKET',
  CONTACTUS_CREATESUPPORTTICKET_SUCCESS = '@@contactus/CONTACTUS_CREATESUPPORTTICKET_SUCCESS',
  CONTACTUS_CREATESUPPORTTICKET_ERROR = '@@contactus/CONTACTUS_CREATESUPPORTTICKET_ERROR',

  CONTACT_RESOURCES_REQUEST = '@@contactus/CONTACT_RESOURCES_REQUEST',
  CONTACT_RESOURCES_SUCCESS = '@@contactus/CONTACT_RESOURCES_SUCCESS',
  CONTACT_RESOURCES_ERROR = '@@contactus/CONTACT_RESOURCES_ERROR',

  SET_ADD_HERO_BAR_LISTENER = '@@contactus/SET_ADD_HERO_BAR_LISTENER'
}

export interface IContactUsState {
  isSending?: boolean;
  isLoadingCountries?: boolean;
  isLoadingCategories?: boolean;
  isLoadingResources?: boolean;
  sentSuccessfully?: boolean;
  failedToSend?: boolean;
  countryCodes?: ICountryCode[];
  supportTicketResponse?: ISupportTicketResponse;
  supportTicketEmail?: string;
  // Field-level errors from a 400 response, keyed by the API's own field name (e.g. `UserEmail`).
  supportTicketFieldErrors?: Record<string, string>;
  // True while the Contact Us hero bar is mounted, signalling the CopilotKit provider to listen
  // for the hero bar's 'copilot-hero-send' events.
  addHeroBarListener?: boolean;
}

export interface IHelpIssueCategory {
  Name: string;
  Code: string;
  IssueCategories: IIssueCategory[];
  Key: string;
}

export interface IContactUsSubmissionFields {
  userFirstName: string;
  userLastName: string;
  userEmail: string;
  issue: string;
  nonprofitName: string;
  userPhone: string;
  category: string;
  countryCode: any;
  userLocale: string;
  role: string;
}

export interface IAgentSupportTicketMetadata {
  source: 'agent';
  threadId?: string;
  aiGeneratedTopic: string;
  aiGeneratedDescription: string;
  turnCountBeforeTicket: number;
}

export interface IContactUsSubmissionForm extends IContactUsSubmissionFields {
  helpCategoryComboValue: any;
}

export interface IIssueCategory {
  Name: string;
  Code: string;
  HelpCategoryCode: string;
  Key: string;
}

export interface ISupportTicketResponse {
  Id: number;
}

export interface IContactUsParameterizedRoute {
  category: string;
  subCategory: string;
  isValid: boolean;
}

export interface ChatHistoryItem {
  role: string;
  content: string;
  timestamp?: string;
}

export interface ReasonCode {
  id: string;
  label: string;
  description?: string;
}

export interface FeedbackBootstrap {
  reasonCodes: ReasonCode[];
  commentHint: string;
  isDynamic: boolean;
  analysisContext?: string;
}

export interface FeedbackSubmission {
  threadId: string;
  responseId: string;
  polarity: 'positive' | 'negative';
  reasonCode: string;
  reasonCodeLabel?: string;
  reasonCodeDescription?: string;
  comment?: string;
}

export interface SessionEndResponse {
  sessionId: string;
  feedbackCount: number;
  successCount: number;
  failedCount: number;
  durationMs: number;
  message: string;
}

